<script>
	import { createEventDispatcher, getContext, onMount } from 'svelte';

	import { keyToken, keyUser, ROLE_VIEWER } from '../../globals.js';
	import { formatAmount, formatCurrency, formatDate, formatPercent } from '../formatting.js';
	import StockChart from './StockChart.svelte';

	const dispatch = createEventDispatcher();

	const { getToken } = getContext(keyToken);
	const token = getToken();
	const { getUser } = getContext(keyUser);
	const user = getUser();

	let isin;
	let stock = {};
	let title = '';

	async function addAssetToWatchlist() {
		if (!token) {
			console.warn('Not logged in!');
			return;
		}

		await fetch('https://ostium.ch/api/borsalino/add_watchlist.php', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8',
				'Authorization': 'JWT ' + encodeURIComponent(token)
			},
			body: JSON.stringify({ isin: isin })
		}).then(result => {
			if (result.ok) {
				result.json().then(data => {
					console.log('Added asset to watchlist:', data);
					dispatch('message', {
						type: 'success',
						text: data.message
					});
					dispatch('update', {
						type: 'watchlist',
						text: data.message
					});
				});
			} else {
				console.warn('Could not add asset to watchlist.', result.statusText);
				result.json().then(data => {
					console.log('Error:', data);
					dispatch('message', {
						type: 'error',
						text: data.error != null ? data.error : data.warning
					});
				});
			}
		});
	}

	async function loadAssetDetails() {
		if (!token) {
			console.warn('Not logged in!');
			return;
		}

		await fetch('https://ostium.ch/api/borsalino/get_asset.php', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8',
				'Authorization': 'JWT ' + encodeURIComponent(token)
			},
			body: JSON.stringify({ isin: isin })
		}).then(result => {
			if (result.ok) {
				result.json().then(data => {
					console.log('Asset details:', data);
					stock = data;
					title = stock.name;
				});
			} else {
				console.warn('Could not load asset details.', result.statusText);
			}
		});
	}

	function closeModal(event) {
		isin = null;
		stock = {};
		title = '';
		return event;
	}

	onMount(() => {
		jQuery('#assetDetailsDialog').on('show.bs.modal', function (event) {
			let target =  event.relatedTarget;
			if (target != null && target.dataset != null && target.dataset['isin'] != null) {
				isin = target.dataset['isin'];
				loadAssetDetails();
			}
		});
		jQuery('.btn-popover').popover({
			container: 'body',
			placement: 'top'
		});
	});
</script>

<div class="modal fade" id="assetDetailsDialog" data-backdrop="static" tabindex="-1" role="dialog">
	<div class="modal-dialog modal-dialog-centered modal-xl" role="document">
		<div class="modal-content bg-dark">
			<div class="modal-header">
				<h5 class="modal-title">Details {title}</h5>
				<button type="button" class="close text-light" on:click={closeModal} data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<div class="container-fluid">
					<div class="row">
						<div class="col-md-2">
							<dl>
								<dt>Date/Time</dt>
								<dd>{formatDate(new Date(1000 * stock.last_price_update))}</dd>
								<dt>Last</dt>
								<dd>{formatCurrency(stock.last / stock.factor, stock.currency)}</dd>
								<dt>Close</dt>
								<dd>{formatCurrency(stock.close_day / stock.factor, stock.currency)}</dd>
								<dt>Diff</dt>
								<dd class="{'text-' + (stock.last < stock.close_day ? 'danger' : 'success')}">
									{stock.last > stock.close_day ? '+' : ''}{formatAmount((stock.last - stock.close_day) / stock.factor)}
									({formatPercent(stock.last / stock.close_day - 1.0)})
								</dd>
								<dt>YTD</dt>
								<dd class="{'text-' + (stock.last < stock.close_year ? 'danger' : 'success')}">
									{stock.last > stock.close_year ? '+' : ''}{formatAmount((stock.last - stock.close_year) / stock.factor)}
									({formatPercent(stock.last / stock.close_year - 1.0)})
								</dd>
								{#if stock.high_52_week != null}
								<dt>52 Weeks High</dt>
								<dd>{formatAmount(stock.high_52_week / stock.factor)}</dd>
								{/if}
								{#if stock.low_52_week != null}
								<dt>52 Weeks Low</dt>
								<dd>{formatAmount(stock.low_52_week / stock.factor)}</dd>
								{/if}
								{#if stock.dividend_amount != null && stock.dividend_date != null}
								<dt>Dividend</dt>
								<dd>
									{formatAmount(stock.dividend_amount / stock.factor)}
									({formatAmount(100 * stock.dividend_amount / stock.last)}%)
								</dd>
								<dt>Dividend Date</dt>
								<dd>{formatDate(new Date(stock.dividend_date))}</dd>
								{/if}
							</dl>
						</div>
						<div class="col-md-10 ml-auto">
							<StockChart {stock} />
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer justify-content-between">
				<div>
					{#if user != null && user.role_id !== ROLE_VIEWER}
					<a href="." class="btn btn-secondary" data-toggle="modal" data-target="#addAlarmDialog" data-isin={stock.isin}>Add alarm</a>
					<a href="." class="btn btn-secondary" data-toggle="modal" data-target="#buySellDialog" data-isin={stock.isin}>Add to portfolio</a>
					<button type="button" class="btn btn-secondary" on:click|preventDefault={addAssetToWatchlist}>Add to watchlist</button>
					{:else}
					<button type="button" class="btn btn-secondary disabled btn-popover" id="addAlarm" data-toggle="popover" data-content="Adding alarms is not available to viewers.">Add alarm</button>
					<button type="button" class="btn btn-secondary disabled btn-popover" id="addToPortfolio" data-toggle="popover" data-content="Adding alarms is not available to viewers.">Add to portfolio</button>
					<button type="button" class="btn btn-secondary disabled btn-popover" id="addToWatchlist" data-toggle="popover" data-content="Adding to watchlist is not available to viewers.">Add to watchlist</button>
					{/if}
				</div>
				<button type="button" class="btn btn-primary" on:click={closeModal} data-dismiss="modal">Close</button>
			</div>
		</div>
	</div>
</div>
